module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.loading.overlay) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', [_c('div', [_vm._v(_vm._s(_vm.loading.message))]), _vm._v(" "), _vm._m(0)])]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('notifications', {
    attrs: {
      "position": "bottom right"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-padding center"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/loading.svg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a47f073!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 2113
// module chunks = 2